var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view project-detail" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.topBtGroupVisdeld,
              expression: "topBtGroupVisdeld"
            }
          ],
          staticClass: "app-main-inner-row operations",
          staticStyle: { "padding-left": "0px" }
        },
        [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "1" },
                    on: { click: _vm.toBackList }
                  },
                  [_vm._v(_vm._s(_vm.$t("ProjectManage.Cancel")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.canSave, no: "2" },
                    on: { click: _vm.doSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("ProjectManage.Save")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.canSave, no: "3" },
                    on: { click: _vm.asyncCharge }
                  },
                  [_vm._v(_vm._s(_vm.$t("ProjectManage.SynchronizeFees")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.botBtGroupVisdeld,
              expression: "botBtGroupVisdeld"
            }
          ],
          staticClass: "app-main-inner-row operations",
          staticStyle: { "padding-left": "0px" }
        },
        [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", no: "4" },
                    on: { click: _vm.toCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "5" },
                    on: { click: _vm.toEdit }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_ProjectModule_delete"],
                        expression: "['button_ProjectModule_delete']"
                      }
                    ],
                    attrs: { type: "danger", no: "6" },
                    on: { click: _vm.toBatchDelete }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", no: "7" },
                    on: { click: _vm.toAdd }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "8" },
                    on: { click: _vm.toExportToExcel }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.exportExcel")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: _vm.yuhaiApiIsEdit,
                      no: "9"
                    },
                    on: { click: _vm.toCloseProject }
                  },
                  [_vm._v(_vm._s(_vm.$t("Project.CloseProject")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: _vm.yuhaiApiIsEdit,
                      no: "10"
                    },
                    on: { click: _vm.toOpenProject }
                  },
                  [_vm._v(_vm._s(_vm.$t("Project.RebuildProject")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "tabs-container", staticStyle: { "margin-top": "5px" } },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("ProjectManage.BasicInformation"),
                    name: "basic"
                  }
                },
                [_c("basic", { ref: "basicTab" })],
                1
              ),
              _vm.notNew
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("ProjectManage.FileHistory"),
                        name: "fileHistory"
                      }
                    },
                    [_c("file-history", { ref: "fileHistoryTab" })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }